module.exports = __webpack_public_path__ + "images/bf1d53236791c618d871262f1ef87654.svg";